<template>
  <v-card class="px-5 py-5">
    <v-form ref="form" lazy-validation>
      <v-row>
        <v-col cols="12" md="6">
          <v-select
            :items="yearItems"
            label="财务年度"
            v-model="form.year"
            hide-details='auto'
            outlined
            item-text='label'
            :rules="required"
            @change="changeYear"
          ></v-select>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field label="固定资产(万元)" hide-details='auto' outlined :rules="number" v-model="form.fixedAssets"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-text-field label="资产总额(万元)" hide-details='auto' outlined :rules="number" v-model="form.assets"></v-text-field>
        </v-col>
          <v-col cols="12" md="6">
          <v-text-field label="净资产(万元)" hide-details='auto' outlined :rules="number" v-model="form.netAssets"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-text-field label="营业收入(万元)" hide-details='auto' @input='countDevRatio' outlined :rules="number" v-model="form.income"></v-text-field>
        </v-col>
          <v-col cols="12" md="6">
          <v-text-field label="主营业务收入(万元)" hide-details='auto' outlined :rules="number" v-model="form.firstIncome"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-text-field label="利润总额(万元)" hide-details='auto' outlined :rules="number" v-model="form.profit"></v-text-field>
        </v-col>
          <v-col cols="12" md="6">
          <v-text-field label="净利润(万元)" hide-details='auto' outlined :rules="number" v-model="form.netProfit"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-text-field label="研发费用(万元)" @input='countDevRatio' outlined :rules="number" v-model="form.development"></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field label="研发占比(百分比)" readonly outlined :rules="number" v-model="form.developmentRatio"></v-text-field>
        </v-col>
      </v-row>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text class="text--disabled" @click='item.show = false'>
        关闭
      </v-btn>
      <v-btn color="primary" :loading="loading" @click='save'>
        保存
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { selectNextYear } from '@/utils/tool.js'
  import { save, getByYear } from '@/api/customer/finance.js'

  export default {
    name: 'CustomerFinance',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          data: null
        })
      },
      show: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      show (n) {
        if (n) {
          this.setData()
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]+.?[0-99]*$/.test(value) || '必须输入数字',
        ],
        yearItems: selectNextYear(),
        form: {
          id: '',
          year: '',
          customerId: '',
          income: '',
          firstIncome: '',
          profit: '',
          netProfit: '',
          assets: '',
          netAssets: '',
          development: '',
          fixedAssets: '',
          developmentRatio: ''
        },
        defForm: {
          id: '',
          year: '',
          customerId: '',
          income: '',
          firstIncome: '',
          profit: '',
          netProfit: '',
          assets: '',
          netAssets: '',
          development: '',
          fixedAssets: '',
          developmentRatio: ''
        }
      }
    },
    methods: {
      setData () {
        if (this.item.data.finances) {
            this.item.data.finances.forEach(element => {
              if (element.year === Number(this.$moment(new Date().getTime()).format('YYYY'))) {
                this.form = JSON.parse(JSON.stringify(element))
              }
            })
          }
      },
      changeYear () {
        const createYear = this.form.year
        this.loading = true
        getByYear(createYear, this.form.customerId).then(res => {
          if (res.status === 200) {
            if (res.data) {
              this.form = JSON.parse(JSON.stringify(res.data))
            } else {
              this.form = JSON.parse(JSON.stringify(this.defForm))
              this.form.year = createYear
              this.form.customerId = this.item.data.id
            }
          }
          this.loading = false
        })
      },
      save () {
        if (this.$refs.form.validate()) {
          this.form.customerId = this.item.data.id
          this.form.followTime = new Date(this.form.followTimeStr).getTime() / 1000
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      countDevRatio () {
        this.form.developmentRatio = (this.form.development / this.form.income * 100).toFixed(2)
      }
    },
    created() {
      this.setData()
    }
  }
</script>

<style lang="sass" scoped>
</style>
